// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_ih2_0 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn_Sge0c 0.3s ease-out;
}

.popup_mfwyV {
    background: var(--f5-background);
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    animation: scaleUp_bnEfR 0.3s ease-out;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.header_v2HAC {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #e6e6e6;

    h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #000;
    }
}

.closeButton_dvw2r {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f0f0f0;
    }

    svg {
        width: 16px;
        height: 16px;
        fill: #666;
    }
}

.content_hnbMY {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.inputGroup_YfZs3 {
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

    input {
        padding: 12px 16px;
        border: 1px solid #e6e6e6;
        border-radius: 8px;
        font-size: 14px;
        background: #fff;
        transition: border-color 0.2s;

        &:focus {
            outline: none;
            border-color: #10a37f;
        }

        &::placeholder {
            color: #999;
        }
    }
}

.methodSelector_V79uz {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.methodButton_WL3W9 {
    padding: 8px 16px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    transition: all 0.2s;

    &:hover {
        background-color: #f8f8f8;
    }

    &.active_YtnWu {
        background-color: #10a37f;
        color: #fff;
        border-color: #10a37f;
    }
}

.testResult_pC5Z4 {
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;

    &.success_DLplv {
        background-color: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
    }

    &.error_SVtvl {
        background-color: #f8d7da;
        color: #721c24;
        border: 1px solid #f5c6cb;
    }
}

.actions_Kr4vG {
    padding: 16px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-top: 1px solid #e6e6e6;
}

.testButton_ukdlJ {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    background-color: #10a37f;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #0d8a6f;
    }

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }

    svg {
        width: 16px;
        height: 16px;
        fill: currentColor;
    }
}

.actionButtons_xlPX2 {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.cancelButton_BDwes {
    padding: 10px 20px;
    background: #fff;
    color: #666;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #f8f8f8;
        border-color: #d0d0d0;
    }
}

.addButton_AF5rE {
    padding: 10px 20px;
    background-color: #10a37f;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #0d8a6f;
    }

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
}

@keyframes fadeIn_Sge0c {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes scaleUp_bnEfR {
    from {
        transform: scale(0.9);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

/* Responsive design */
@media (max-width: 768px) {
    .popup_mfwyV {
        width: 95%;
        margin: 20px;
    }

    .content_hnbMY {
        padding: 16px 20px;
    }

    .actions_Kr4vG {
        padding: 16px 20px 20px;
    }

    .methodSelector_V79uz {
        gap: 6px;
    }

    .methodButton_WL3W9 {
        padding: 6px 12px;
        font-size: 11px;
    }

    .actionButtons_xlPX2 {
        flex-direction: column;
    }
} `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ApiPage/AddEndpointPopup.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qCAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,sCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;;IAEhC;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;;IAEjC;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,6BAA6B;;QAE7B;YACI,aAAa;YACb,qBAAqB;QACzB;;QAEA;YACI,WAAW;QACf;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;;IAEpB;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB;QACI,yBAAyB;QACzB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,yBAAyB;IAC7B;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;;IAEjC;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;;IAEpB;QACI,yBAAyB;QACzB,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;;IAEjC;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    animation: fadeIn 0.3s ease-out;\n}\n\n.popup {\n    background: var(--f5-background);\n    border-radius: 12px;\n    width: 90%;\n    max-width: 500px;\n    max-height: 90vh;\n    overflow-y: auto;\n    animation: scaleUp 0.3s ease-out;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px 16px;\n    border-bottom: 1px solid #e6e6e6;\n\n    h3 {\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: #000;\n    }\n}\n\n.closeButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s;\n\n    &:hover {\n        background-color: #f0f0f0;\n    }\n\n    svg {\n        width: 16px;\n        height: 16px;\n        fill: #666;\n    }\n}\n\n.content {\n    padding: 20px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.inputGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    label {\n        font-size: 14px;\n        font-weight: 500;\n        color: #333;\n    }\n\n    input {\n        padding: 12px 16px;\n        border: 1px solid #e6e6e6;\n        border-radius: 8px;\n        font-size: 14px;\n        background: #fff;\n        transition: border-color 0.2s;\n\n        &:focus {\n            outline: none;\n            border-color: #10a37f;\n        }\n\n        &::placeholder {\n            color: #999;\n        }\n    }\n}\n\n.methodSelector {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.methodButton {\n    padding: 8px 16px;\n    border: 1px solid #e6e6e6;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    transition: all 0.2s;\n\n    &:hover {\n        background-color: #f8f8f8;\n    }\n\n    &.active {\n        background-color: #10a37f;\n        color: #fff;\n        border-color: #10a37f;\n    }\n}\n\n.testResult {\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n\n    &.success {\n        background-color: #d4edda;\n        color: #155724;\n        border: 1px solid #c3e6cb;\n    }\n\n    &.error {\n        background-color: #f8d7da;\n        color: #721c24;\n        border: 1px solid #f5c6cb;\n    }\n}\n\n.actions {\n    padding: 16px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-top: 1px solid #e6e6e6;\n}\n\n.testButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 20px;\n    background-color: #10a37f;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover:not(:disabled) {\n        background-color: #0d8a6f;\n    }\n\n    &:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n    }\n\n    svg {\n        width: 16px;\n        height: 16px;\n        fill: currentColor;\n    }\n}\n\n.actionButtons {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n}\n\n.cancelButton {\n    padding: 10px 20px;\n    background: #fff;\n    color: #666;\n    border: 1px solid #e6e6e6;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover {\n        background-color: #f8f8f8;\n        border-color: #d0d0d0;\n    }\n}\n\n.addButton {\n    padding: 10px 20px;\n    background-color: #10a37f;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover:not(:disabled) {\n        background-color: #0d8a6f;\n    }\n\n    &:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes scaleUp {\n    from {\n        transform: scale(0.9);\n        opacity: 0;\n    }\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .popup {\n        width: 95%;\n        margin: 20px;\n    }\n\n    .content {\n        padding: 16px 20px;\n    }\n\n    .actions {\n        padding: 16px 20px 20px;\n    }\n\n    .methodSelector {\n        gap: 6px;\n    }\n\n    .methodButton {\n        padding: 6px 12px;\n        font-size: 11px;\n    }\n\n    .actionButtons {\n        flex-direction: column;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_ih2_0`,
	"fadeIn": `fadeIn_Sge0c`,
	"popup": `popup_mfwyV`,
	"scaleUp": `scaleUp_bnEfR`,
	"header": `header_v2HAC`,
	"closeButton": `closeButton_dvw2r`,
	"content": `content_hnbMY`,
	"inputGroup": `inputGroup_YfZs3`,
	"methodSelector": `methodSelector_V79uz`,
	"methodButton": `methodButton_WL3W9`,
	"active": `active_YtnWu`,
	"testResult": `testResult_pC5Z4`,
	"success": `success_DLplv`,
	"error": `error_SVtvl`,
	"actions": `actions_Kr4vG`,
	"testButton": `testButton_ukdlJ`,
	"actionButtons": `actionButtons_xlPX2`,
	"cancelButton": `cancelButton_BDwes`,
	"addButton": `addButton_AF5rE`
};
export default ___CSS_LOADER_EXPORT___;
